export default
`­Beste {naam},

Wij hebben de zending {barcode} geannuleerd.
Helaas kunt u deze zending niet meer verwachten.

Met vriendelijke groet,
{bedrijfsnaam}`
